type Props = {
  width?: string;
  height?: string;
  viewBox?: string;
  strokeColor?: string;
  strokeWidth?: string;
};

// Plain download arrow: vertical stem + arrowhead, no base tray.
const DownloadArrowIcon = (props: Props) => {
  const {
    width = '12',
    height = '12',
    viewBox = '0 0 14 14',
    strokeColor = 'var(--primary)',
    strokeWidth = '2.2',
  } = props;
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none">
      <path
        d="M7 2V10.5"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 6.5L7 10.5L11 6.5"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DownloadArrowIcon;
